import React from 'react';
import {SignoutCallbackComponent} from "redux-oidc";
import {withRouter} from 'react-router-dom';
import userManager from "../../userManager";

const Logout = props => (
  <SignoutCallbackComponent
    userManager={userManager}
    successCallback={(response) => {
      props.history.push('/');
    }}
    errorCallback={error => {
      props.history.push('/');
    }}
  >
    <div>Logging out...</div>
  </SignoutCallbackComponent>
)

export default withRouter(props => <Logout {...props}/>);
